import { Editable } from "@/components/Editable";
import { ImageEditArea } from "@/components/ImageEditArea";
import { LinkEditButton } from "@/components/LinkEditButton";
import { useContent } from "@/contexts/ContentContext";
import { CMS } from "@/constants/testIds/cms";

export default function VideosPage() {
  const { content } = useContent();
  if (!content) return null;

  return (
    <main id="page-videos">
      <section className="videos-header">
        <div className="wrap">
          <span className="eyebrow">Watch and practice</span>
          <Editable path="videosPage.heading" tag="h1" />
          <Editable path="videosPage.intro" tag="p" />
        </div>
      </section>
      <section className="videos-grid">
        <div className="wrap">
          <div className="mod-grid">
            {content.videos.map((v, i) => (
              <div className="mod-card" key={i}>
                <ImageEditArea
                  path={`videos.${i}.thumb`}
                  className="video-thumb"
                  label="Change thumbnail"
                  testId={`${CMS.videoThumbEdit}-${i}`}
                />
                <Editable path={`videos.${i}.title`} tag="h3" />
                <Editable path={`videos.${i}.desc`} tag="p" />
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "14px" }}>
                  <a
                    className="btn btn-secondary"
                    style={{ padding: "8px 18px", fontSize: "16px" }}
                    href={v.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`video-watch-link-${i}`}
                  >
                    Watch video
                  </a>
                  <LinkEditButton path={`videos.${i}.link`} title="Where should 'Watch video' link to?" testId={`${CMS.videoLinkEdit}-${i}`} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
